import { render, staticRenderFns } from "./PointGmoneyError.vue?vue&type=template&id=2001c6d7"
import script from "./PointGmoneyError.vue?vue&type=script&lang=js"
export * from "./PointGmoneyError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports